import { render, staticRenderFns } from "./MensagemPersonalizada.vue?vue&type=template&id=77562a5c&"
import script from "./MensagemPersonalizada.vue?vue&type=script&lang=js&"
export * from "./MensagemPersonalizada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports